<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>江中游学院</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <h4>
      继续深造请加江中游老师QQ：390941087<a href="tencent://message/?uin=390941087&Site=&Menu=yes"><img border="0" src="https://pub.idqqimg.com/wpa/images/counseling_style_52.png" alt="点击这里给江老师发消息" title="点击这里给江老师发消息"/></a>   
      <br>
      江中游学院网址：<a target="_blank" href="http://www.jiangzhongyou.net/">江中游学院<img border="0" src="" alt="" title="江中游学院"></a>
    </h4>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
  a{
    text-decoration: none;
  }
  h4{
    margin: 20px;
    img {
      vertical-align: -5px;
    }
  }
</style>